module.exports = __webpack_public_path__ + "static/media/plus-square.3703a672.svg";